import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { getBudgets, type PeriodSelection, pinBudget, queryKeys } from '@/api/fpa'

/** Budgets with lines in the selected period's months (`GET /v1/budgets`). */
export function useBudgetsQuery(sel: PeriodSelection) {
  return useQuery({
    queryKey: queryKeys.budgets(sel),
    queryFn: ({ signal }) => getBudgets(sel, signal),
    staleTime: 60_000,
  })
}

/** Pin FPA's budget (admin); `null` follows Sage's default again. Refreshes every runway. */
export function usePinBudget() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (budgetId: string | null) => pinBudget(budgetId),
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.budgetsAll }),
        queryClient.invalidateQueries({ queryKey: queryKeys.runwayAll }),
      ])
    },
  })
}
